import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

/**
 * Route table with lazy-loading for heavy screens. The interview room (media,
 * audio, avatar) is code-split so it never bloats the initial bundle — a core
 * performance requirement. Screens marked TODO are scaffolded next; the router
 * shape is the contract they'll fill.
 */
const RequireAuth = lazy(() => import('./components/RequireAuth'));
const SetupWizard = lazy(() => import('./pages/SetupWizard'));
const InterviewRoom = lazy(() => import('./pages/InterviewRoom'));
const AptitudeTest = lazy(() => import('./pages/AptitudeTest'));
const AptitudeResults = lazy(() => import('./pages/AptitudeResults'));
const ReportPage = lazy(() => import('./pages/ReportPage'));
const HistoryPage = lazy(() => import('./pages/HistoryPage'));
const AdminLogin = lazy(() => import('./pages/admin/AdminLogin'));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));
const AdminQuestionBank = lazy(() => import('./pages/admin/AdminQuestionBank'));
const AdminCatalogue = lazy(() => import('./pages/admin/AdminCatalogue'));
const AdminUsers = lazy(() => import('./pages/admin/AdminUsers'));

function Loading() {
  return <div style={{ padding: 48, color: 'var(--nova-text-soft)' }}>Loading…</div>;
}

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/setup" replace /> },
  {
    element: <Suspense fallback={<Loading />}><RequireAuth /></Suspense>,
    children: [
      { path: '/setup', element: <Suspense fallback={<Loading />}><SetupWizard /></Suspense> },
      { path: '/interview/:sessionId', element: <Suspense fallback={<Loading />}><InterviewRoom /></Suspense> },
      { path: '/aptitude/:sessionId', element: <Suspense fallback={<Loading />}><AptitudeTest /></Suspense> },
      { path: '/aptitude-results/:reportId', element: <Suspense fallback={<Loading />}><AptitudeResults /></Suspense> },
      { path: '/report/:reportId', element: <Suspense fallback={<Loading />}><ReportPage /></Suspense> },
      { path: '/history', element: <Suspense fallback={<Loading />}><HistoryPage /></Suspense> },
    ],
  },
  { path: '/admin/login', element: <Suspense fallback={<Loading />}><AdminLogin /></Suspense> },
  {
    path: '/admin',
    element: <Suspense fallback={<Loading />}><AdminLayout /></Suspense>,
    children: [
      { index: true, element: <Navigate to="/admin/questions" replace /> },
      { path: 'questions', element: <Suspense fallback={<Loading />}><AdminQuestionBank /></Suspense> },
      { path: 'catalogue', element: <Suspense fallback={<Loading />}><AdminCatalogue /></Suspense> },
      { path: 'users', element: <Suspense fallback={<Loading />}><AdminUsers /></Suspense> },
    ],
  },
]);
